module.exports = __webpack_public_path__ + "img/penguin.0bc56d23.png";